export default __webpack_public_path__ + "static/media/instagram.a9ec6f1a.png";